import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';

import { Subscription } from 'rxjs';

import { LocationInfo } from 'emr-ng-shared';

import { IShipmentFilterLocation } from 'app-modules/core/store/models/shipment-filter-location.interface';

import { ShipmentFilterService } from 'app-modules/core/store/shipment-filter/shipment-filter.service';
import { LocationService } from 'app-modules/core/services/location.service';
import { IShipmentFilterState } from 'app-modules/core/store/models/shipment-filter-state.interface';
import { destination } from 'app-modules/core/consts/localization';
import { NgFor, NgIf } from '@angular/common';

class LocationInfoListItem {
    get text() { return this.locationInfo.LocationName + ' - ' + this.locationInfo.Address1; }
    get value() { return this.locationInfo.LocationId; }
    constructor(public locationInfo: LocationInfo) { }
}

@Component({
    selector: 'app-shipment-filter-destination-summary',
    templateUrl: 'shipment-filter-destination-summary.component.html',
    styleUrls: ['shipment-filter-destination-summary.component.css'],
    standalone: true,
    imports: [NgIf, NgFor]
}) export class ShipmentFilterDestinationSummaryComponent implements OnInit, OnDestroy {
    destinationList: LocationInfo[] = [];
    filter: number[];
    selectedList: LocationInfoListItem[] = [];

    destinationListSubscription: Subscription;
    destinationFilterSubscription: Subscription;
    @Input() shipmentFilter: IShipmentFilterState;
    @Input() isHugeCustomer: boolean;
    @Output() summaryRemove = new EventEmitter();

    constructor(
        private locationSvc: LocationService,
        private filterSvc: ShipmentFilterService
    ) { }

    ngOnInit() {
        this.destinationListSubscription = this.locationSvc.destinationList$.subscribe(n => this.onDestinationListChange(n.list));
        this.destinationFilterSubscription = this.filterSvc.destinationFilter$.subscribe(n => this.onDestinationFilterChange(n));
    }

    ngOnDestroy() {
        this.destinationListSubscription.unsubscribe();
        this.destinationFilterSubscription.unsubscribe();
    }

    onDestinationListChange(destinationList: LocationInfo[]) {
        this.destinationList = destinationList;
        this.filterDestinationList();
    }

    onDestinationFilterChange(filter: number[]) {
        this.filter = filter;
        this.filterDestinationList();
    }

    filterDestinationList() {
        this.selectedList = [];

        if (this.filter) {
            this.destinationList.forEach(item => {
                if (this.filter.indexOf(item.LocationId) >= 0) {
                    this.selectedList.push(new LocationInfoListItem(item));
                }
            });
        }
    }

    clearSelectedFilter(LocationId: number) {
        this.shipmentFilter.destination = this.shipmentFilter.destination.filter(k => k !== LocationId);
        this.filterSvc.changeShipmentFilterWithoutShipmentListUpdate(this.shipmentFilter);
        if (this.summaryRemove) {
            this.summaryRemove.emit({ title: destination, value: this.shipmentFilter.destination });
        }
    }
}


